import { create } from 'zustand';
import i18n from '@i18n/config';

const STORAGE_KEY = 'avne-chen-language';

// Get initial language from localStorage or default to Hebrew
const getInitialLanguage = () => {
  if (typeof window !== 'undefined') {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'en' || stored === 'he') {
      return stored;
    }
  }
  return 'he';
};

const useLanguageStore = create((set) => {
  const initialLanguage = getInitialLanguage();
  
  // Initialize i18n and document direction
  if (typeof window !== 'undefined') {
    i18n.changeLanguage(initialLanguage);
    document.documentElement.dir = initialLanguage === 'he' ? 'rtl' : 'ltr';
    document.documentElement.lang = initialLanguage;
  }

  return {
    language: initialLanguage,
    setLanguage: (lang) => {
      if (typeof window !== 'undefined') {
        localStorage.setItem(STORAGE_KEY, lang);
        i18n.changeLanguage(lang);
        document.documentElement.dir = lang === 'he' ? 'rtl' : 'ltr';
        document.documentElement.lang = lang;
      }
      set({ language: lang });
    },
  };
});

export default useLanguageStore;

